import { assertNotEmpty } from '@festina-life/core'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { useTemplateContext } from '../../context/templateContext'
import { configurationItem } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useOperationsContext } from '../../workspace/operationsContext'

export const useNavigateToCurrentTemplatePath = () => {
  const navigate = useNavigate()
  const { server, branch } = useNavigationParams()
  const { workspaceKey } = useOperationsContext()
  const { templateVersion } = useTemplateContext()

  return useCallback(
    async (path: string) => {
      assertNotEmpty(templateVersion)

      await navigate(
        configurationItem({
          path,
          branch,
          type: 'template',
          server,
          workspaceName: workspaceKey?.name,
          layer: templateVersion.layer,
          block: templateVersion.block,
          itemId: templateVersion.versionInfo.identifier,
        }),
      )
    },
    [templateVersion, server, branch, workspaceKey?.name, navigate],
  )
}
